import React from 'react'
import PropTypes from 'prop-types'
import Active from './components/Active/Active.container'
import Skeleton from 'shared/components/common/Skeleton/Skeleton.component'
import Popover from 'shared/components/common/Popover/Popover.component'
import PopoverSection from 'shared/components/common/Popover/components/Section/Section.component'
import PopoverMenu from 'shared/components/common/Popover/components/Menu/Menu.component'
import PopoverItem from 'shared/components/common/Popover/components/Item/Item.component'
import Scrollable from 'shared/components/common/Scrollable/Scrollable.component'
import { createDivAtom } from 'shared/atoms/factory'
import { useAuth } from 'shared/utils/auth'

import styles from './Organisations.module.scss'

import iconAdvanced from 'shared/assets/icons/menu-advanced.svg'
import iconTeam from 'shared/assets/icons/menu-team.svg'
import iconProfile from 'shared/assets/icons/menu-profile.svg'
import iconBilling from 'shared/assets/icons/menu-billing.svg'
import iconSignOut from 'shared/assets/icons/menu-signout.svg'

const SkeletonWrapper = createDivAtom()

const renderOrganisationItems = (organisations, onClick) => organisations.map((item, i) => (
  <PopoverItem
    key={i}
    title={item.name}
    titleClassName={styles.itemTitle}
    onClick={onClick(item)}
  />
))

const renderSecionItems = items => items.map((item, i) => (
  <PopoverItem
    key={i}
    title={item.title}
    icon={item.icon}
    onClick={item.onClick}
  />
))

const Organisations = ({
  organisation,
  organisations,
  onNavigate,
  selectOrganisation
}) => {
  const { logout } = useAuth()

  const popoverSecondSection = [
    { title: 'Organisation settings', icon: iconAdvanced, onClick: onNavigate('settings/organisation/general') },
    { title: 'Members', icon: iconTeam, onClick: onNavigate('settings/organisation/members') },
    { title: 'Billings', icon: iconBilling, onClick: onNavigate('settings/organisation/billing') }
  ]
  const popoverThirdSection = [
    { title: 'User Profile', icon: iconProfile, onClick: onNavigate('settings/my/profile') },
    { title: 'Sign out', icon: iconSignOut, onClick: logout }
  ]

  let popover
  const isOrganisationLoaded = !!organisation
  const isOrganisationsLoaded = Array.isArray(organisations)

  const onItemClick = item => () => {
    if(popover) popover.hide()

    selectOrganisation(item)
  }

  return (
    <main className={styles.wrapper}>
      {
        isOrganisationLoaded
          ? (
            <Popover
              ref={ref => popover = ref}
              trigger={<Active />}
              showChevron
            >
              <PopoverMenu>

                <PopoverSection
                  title='Switch organisation'
                  align='left'
                >
                  <Scrollable
                    className={styles.scrollable}
                  >

                    {
                      isOrganisationsLoaded
                        ? renderOrganisationItems(organisations, onItemClick)
                        : <span className={styles.noContent} >No Organisations</span>
                    }

                  </Scrollable>
                </PopoverSection>

                <PopoverSection>
                  {renderSecionItems(popoverSecondSection)}
                </PopoverSection>

                {renderSecionItems(popoverThirdSection)}

              </PopoverMenu>
            </Popover>
          )
          : (
            <SkeletonWrapper
              className={styles.skeletonWrapper}
            >
              <Skeleton
                width="80px"
                height="8px"
                style={{
                  marginRight: '16px'
                }}
              />
              <Skeleton
                width="22px"
                height="22px"
              />
            </SkeletonWrapper>
          )
      }
    </main>
  )
}

Organisations.propTypes = {
  organisation: PropTypes.object,
  organisations: PropTypes.any,
  onNavigate: PropTypes.func,
  selectOrganisation: PropTypes.func
}

export default Organisations
